const PLATFORM_OWNER_USERNAMES = new Set(['aviato']);

/**
 * Determine whether the current user is the Aviato platform owner.
 *
 * The reserved username (``aviato``) is only honoured when the user's JWT
 * `tenant_schema` claim points at the ``public`` schema — the legitimate
 * platform-owner identity lives there. Any tenant customer who happens
 * to pick ``aviato`` as their username inside their own schema must NOT
 * be treated as the platform owner, otherwise the UI would expose
 * platform-wide controls (and request `show_all=true`) to a regular
 * tenant user. This mirrors the backend `is_platform_admin_user` guard
 * in ``api/permissions.py``.
 */
export function isAviatoPlatformOwner(user) {
  if (!user || typeof user !== 'object') {
    return false;
  }

  if (user.is_aviato_admin === true || user.is_platform_owner === true) {
    return true;
  }

  const username = String(user.username || '').trim().toLowerCase();
  if (!PLATFORM_OWNER_USERNAMES.has(username)) {
    return false;
  }

  const tenantSchema = String(user.tenant_schema || user.schema_name || '').trim().toLowerCase();
  return tenantSchema === 'public';
}

export default isAviatoPlatformOwner;
